<template>
    <DashboardEditSection class="AccountForm" title="Account">
        <div class="inlineForm">
            <FormInput :value="user.email" label="Email" disabled/>
            <Button class="link" @click="handleChangeEmail">Change Email</Button>
        </div>
        <div class="inlineForm">
            <FormPasswordInput value="••••••" type="password" label="Password" disabled/>
            <Button class="link" @click="handleChangePassword">Change Password</Button>
        </div>
    </DashboardEditSection>
</template>


<script>
import { mapState } from 'vuex';
import DashboardEditSection from '@/components/DashboardEditSection';
import ChangeEmailModal from '@/components/modals/ChangeEmailModal';
import ChangePasswordModal from '@/components/modals/ChangePasswordModal';

export default {
    name: 'AccountForm',

    components: { DashboardEditSection },

    computed: {
        ...mapState('auth', ['user']),
    },

    methods: {
        handleChangeEmail() {
            this.$modal.show(ChangeEmailModal, {}, { height: 'auto', scrollable: true });
        },

        handleChangePassword() {
            this.$modal.show(ChangePasswordModal, {}, { height: 'auto', scrollable: true });
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.AccountForm {
    .inlineForm {
        position: relative;

        .Button {
            position: absolute;
            margin-top: 34px;
            margin-right: 3px;
            padding: 0 15px;
            top: 0;
            right: 0;
            height: 30px;
            line-height: 1;
            border: none;
            background-color: $bg-color-3;
        }
    }

    .saveBtn {
        display: block;
        margin-left: auto;
    }
}
</style>
